import "../scss/style.scss";

import { buttonActionFunc } from "./common/_buttonAction";
import { headerFunc } from "./common/_header";
import { footerFunc } from "./common/_footer";
import { commonFunc } from "./common/_common";
import { homeFunc } from "./pages/_home";
import { columnFunc } from "./pages/_column";
import { columnIndexFunc } from "./pages/_columnIndex";
import jobfaorForm from "./pages/_jobfaorForm";
import company from "./pages/_company";

$(function () {
  $('.p-column-article__entry a[target="_blank"]').each(function () {
    $(this).append('<span class="icon"></span>');
  });
});

$(window).on("load", function () {
  commonFunc();
  headerFunc();
  footerFunc();
  buttonActionFunc();
  if ( $('.p-home').length ) {
    homeFunc();
  }
  if ( $('.p-column-article').length ) {
    columnIndexFunc();
  }
  if ( $('.p-column').length ) {
    columnFunc();
  }
  if ( $('#jobfair-form').length ) {
    jobfaorForm();
  }
  if ( $('.p-company').length ) {
    company();
  }

  $(function(){
    $('a[href^="#"]').click(function(){
      var adjust = -92;
      if ( $(".p-about").length ) var adjust = 0;
      var speed = 400;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top + adjust;
      $('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
    });
  });
});
